export enum SessionStorageKeyEnum {
    AUTH_FLOW_CODE_VERIFIER = 'auth_flow_code_verifier',
    AUTH_FLOW_STATE = 'auth_flow_state',
    DISMISSED_ANNOUNCEMENTS = 'dismissed_announcements',
    NOTIFICATION_TEMPLATE_MODULE = 'notification_template_module',
}
